var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "select-input field", style: { maxWidth: _vm.maxWidth } },
    [
      _c("v-select", {
        style: { maxWidth: _vm.maxWidth },
        attrs: {
          disabled: _vm.disabled,
          inputId: _vm.name,
          options: _vm.options,
          searchable: false,
          value: _vm.value
        },
        on: { input: _vm.onSelectChange }
      }),
      _vm._v(" "),
      _c(
        "label",
        {
          style: { backgroundColor: _vm.backgroundColor },
          attrs: { for: _vm.name }
        },
        [_vm._v(_vm._s(_vm.label))]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-201e3ddc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-201e3ddc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/select-input.vue
// module id = 1354
// module chunks = 0